import { siteClearance } from '@utils/clearanceHelpers'
export default [
  {
    path: '/mx/:store/planning',
    component: () => import('@views/empty-router-view.vue'),
    children: [
      {
        path: '',
        name: 'team-week-selection',
        component: () => import('@modules/planning/views/planning-setup/planning-setup-view.vue'),
        meta: {
          planningMode: 'week',
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'consolidations',
        name: 'consolidationsModification',
        component: () => import('@/modules/collaborators/views/consolidations/planning-consolidations.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'biweeklyPlanning',
        name: 'team-biweekly-selection',
        component: () => import('@modules/planning/views/planning-setup/planning-setup-view.vue'),
        meta: {
          planningMode: 'biweekly',
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'dailyPlanning',
        name: 'team-daily-selection',
        component: () => import('@modules/planning/views/planning-setup/planning-setup-view.vue'),
        meta: {
          planningMode: 'daily',
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'approvals',
        name: 'planning-approvals',
        component: () => import('@components/planning/planning-approvals/planning-approvals.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director],
        },
      },
      {
        path: 'dailyPlanningStore',
        name: 'team-daily-store-selection',
        component: () => import('@modules/planning/views/planning-daily-store/planning-daily-store.vue'),
        meta: {
          authRequired: true,
          authorize: [
            ...siteClearance.admin,
            ...siteClearance.director,
            ...siteClearance.responsible,
            ...siteClearance.responsibleOperation,
            ...siteClearance.collaborator,
          ],
        },
      },
      {
        path: 'dailyPlanningStore/:date',
        name: 'team-daily-store-view',
        component: () => import('@modules/planning/views/planning-daily-store/planning-daily-store.vue'),
        meta: {
          authRequired: true,
          authorize: [
            ...siteClearance.admin,
            ...siteClearance.director,
            ...siteClearance.responsible,
            ...siteClearance.responsibleOperation,
            ...siteClearance.collaborator,
          ],
        },
        props: true,
      },
      {
        path: 'biweeklyPlanningStore',
        name: 'team-biweekly-store-selection',
        component: () => import('@modules/planning/views/planning-biweekly-store/planning-biweekly-store.vue'),
        meta: {
          authRequired: true,
          authorize: [
            ...siteClearance.admin,
            ...siteClearance.director,
            ...siteClearance.responsible,
            ...siteClearance.responsibleOperation,
            ...siteClearance.collaborator,
          ],
        },
      },
      {
        path: 'biweeklyPlanningStore/:start/:end/',
        name: 'team-biweekly-store-view',
        component: () => import('@modules/planning/views/planning-biweekly-store/planning-biweekly-store.vue'),
        meta: {
          authRequired: true,
          authorize: [
            ...siteClearance.admin,
            ...siteClearance.director,
            ...siteClearance.responsible,
            ...siteClearance.responsibleOperation,
            ...siteClearance.collaborator,
          ],
        },
        props: true,
      },
    ],
  },

  // Calendar Store planning views
  {
    path: '/mx/:store/planning-calendar/:startDate/:teamId',
    component: () => import('@views/empty-router-view.vue'),
    children: [
      {
        path: '',
        redirect: (to) => ({
          name: 'store-week-planning',
          params: to.params,
          meta: {
            planningMode: 'week',
            authRequired: true,
            authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          },
        }),
      },
      {
        path: 'week',
        name: 'store-week-planning',
        component: () => import('@modules/planning/views/planning-store/planning-store-view.vue'),
        meta: {
          planningMode: 'week',
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'biweekly',
        name: 'store-biweekly-planning',
        component: () => import('@modules/planning/views/planning-store/planning-store-view.vue'),
        meta: {
          planningMode: 'biweekly',
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'daily',
        name: 'store-daily-planning',
        component: () => import('@modules/planning/views/planning-store/planning-store-view.vue'),
        meta: {
          planningMode: 'daily',
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
    ],
  },

  /// PLANNING TEMPLATE
  {
    path: '/mx/:store',
    component: () => import('@views/empty-router-view.vue'),
    children: [
      {
        path: 'planningTemplate',
        name: 'planning-template-team-selection',
        component: () => import('@modules/planning/views/planning-template/planning-template-team-selection.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'planningTemplate/:teamId/:templateId',
        name: 'planning-template',
        component: () => import('@modules/planning/views/planning-template/planning-template.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'planningTemplateManagement',
        name: 'planning-template-management-selection',
        component: () => import('@modules/planning/views/planning-template/planning-template-management-selection.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
      {
        path: 'planningTemplateManagement/:date/:teamId',
        name: 'planning-template-management',
        component: () => import('@modules/planning/views/planning-template/planning-template-management.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
    ],
  },

  // Calendar Employee planning for Responsibles
  {
    path: '/mx/:store/planning/monthPlanning',
    component: () => import('@views/empty-router-view.vue'),
    children: [
      {
        path: '',
        name: 'collaborator-setup-planning-selection',
        component: () => import('@modules/planning/views/planning-sellers-setup/planning-seller-setup-view.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
        },
      },
    ],
  },
  // Calendar Employee planning views
  {
    path: '/mx/monthPlanning/:collaboratorId',
    component: () => import('@views/empty-router-view.vue'),
    children: [
      {
        path: '',
        name: 'collaborator-setup-planning',
        component: () => import('@modules/planning/views/planning-sellers-setup/planning-seller-setup-view.vue'),
        meta: {
          authRequired: true,
          authorize: [
            ...siteClearance.admin,
            ...siteClearance.director,
            ...siteClearance.responsible,
            ...siteClearance.responsibleOperation,
            ...siteClearance.collaborator,
          ],
        },
      },
      {
        path: 'calendars/:store?/:month',
        name: 'collaborator-calendar-planning',
        component: () => import('@modules/planning/views/planning-sellers-calendars/planning-sellers-callendars-view.vue'),
        meta: {
          authRequired: true,
          authorize: [
            ...siteClearance.admin,
            ...siteClearance.director,
            ...siteClearance.responsible,
            ...siteClearance.responsibleOperation,
            ...siteClearance.collaborator,
          ],
        },
      },
    ],
  },
  {
    path: '/mx/reports/incidents',
    name: 'incident-report-global',
    component: () => import('@modules/reports/views/incidents/incidents-view.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin],
    },
  },
]
